export const FormLabel = {
  baseStyle: {
    width: 'fit-content',
    height: '19px',
  },
};
